"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectType = void 0;
var RedirectType;
(function (RedirectType) {
    RedirectType["home"] = "home";
    RedirectType["sportsbook"] = "sportsbook";
    RedirectType["pick5"] = "pick5";
    RedirectType["pick6"] = "pick6";
    RedirectType["vleague"] = "vleague";
    RedirectType["vpenalty"] = "vpenalty";
    RedirectType["termsandconditions"] = "termsandconditions";
    RedirectType["howtoplay"] = "howtoplay";
    RedirectType["dreamteam"] = "dreamteam";
    RedirectType["lobby"] = "lobby";
    RedirectType["jackpot"] = "jackpot";
    RedirectType["faqs"] = "faqs";
    RedirectType["signup"] = "signup";
    RedirectType["exit"] = "exit";
    RedirectType["error"] = "error";
    RedirectType["claimprize"] = "claimprize";
    RedirectType["register"] = "register";
    RedirectType["correctorder"] = "correctorder";
    RedirectType["account"] = "account";
    RedirectType["bracket"] = "bracket";
    RedirectType["adminpage"] = "adminpage";
})(RedirectType = exports.RedirectType || (exports.RedirectType = {}));
